import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { fetchCleanerPropertyDetail } from "@/lib/fetchCleanerPropertyDetail";
import { isValidCleanerEntityId } from "@/lib/cleanerQueryGuards";
import { cleanerSectionsQueryKey } from "@/lib/cleanerQueryKeys";

const STALE_MS = 1000 * 60 * 5;
const GC_MS = 1000 * 60 * 30;

export function useCleanerPropertyDetail(
  propertyId: string | undefined,
  orgId: string | undefined
) {
  const detailQueryReady = isValidCleanerEntityId(propertyId) && isValidCleanerEntityId(orgId);

  return useQuery({
    queryKey: cleanerSectionsQueryKey(propertyId, orgId),
    queryFn: () => fetchCleanerPropertyDetail(propertyId!, orgId!),
    enabled: detailQueryReady,
    staleTime: STALE_MS,
    gcTime: GC_MS,
    placeholderData: keepPreviousData,
  });
}
